<template>
  <v-card class="mt-2">
    <v-data-table
      :headers="headers"
      :items="results"
      :loading="loading"
      :pagination.sync="pagination"
      :rows-per-page-items="[10]"
      :total-items="pagination.totalItems"
      class="elevation-0"
      item-key="companyId"
      select-all
      v-model="selected"
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
        </td>
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.type == 'SUPPLIER' ? 'フォワダー' : props.item.type == 'PARTNER' ? '海外取引先' : props.item.type }}</td>
        <td>{{ props.item.countryName }}</td>
        <td>{{ props.item.contact }}</td>
        <td>{{ props.item.tel }}</td>
        <td>{{ props.item.fax}}</td>
        <td>{{ props.item.registrationNumber}}</td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['item'],
  data() {
    return {
      headers: [
        { text: 'CD', value: 'code', sortable: false },
        { text: '企業', value: 'name', sortable: false },
        { text: '企業区分', value: 'type', sortable: false },
        { text: '所在地', value: 'countryName', sortable: false },
        { text: '担当窓口', value: 'contact', sortable: false },
        { text: '代表電話', value: 'tel', sortable: false },
        { text: '代表FAX', value: 'fax', sortable: false },
        { text: '登録番号', value: 'registrationNumber', sortable: false }
      ],
      result: [],
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1
      }
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.item,
          ...this.$pageable()
        }
      }
    },
    load() {
      this.autoload = true
      this.loading = true
      this.$http.get('/companies', this.params()).then(res => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },

    downloadLoad() {
      this.$http
        .get('/companies', {
          params: {
            ...this.item,
            ...this.$pageable(),
            size: 99999,
            page: 0
          }
        })
        .then(res => {
          this.$exportTable(
            res.data.content,
            this.headers.map(f => f.value),
            this.headers.map(f => f.text),
            '企業マスター検索結果'
          )
        })
    },

    assign() {
      this.$emit('passSelected', this.selected)
    }
  },
  mounted() {},
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
    selected() {
      this.assign()
    }
  }
}
</script>
